import instance, { customConfig } from "../../../Utils/Interceptors/Interceptor";

const BusquedaEventosConcesion = async (values) => {
    try {
        const resultado = await instance.Backend.post("/Bitacora/BusquedaBitacoraEventoConcesion",values, customConfig);

        return resultado

    } catch (error) {

        console.log(error);

    }

}
export { BusquedaEventosConcesion };